import { render, staticRenderFns } from "./TableSupportTeam.vue?vue&type=template&id=1c711826&"
import script from "./TableSupportTeam.vue?vue&type=script&lang=js&"
export * from "./TableSupportTeam.vue?vue&type=script&lang=js&"
import style0 from "./TableSupportTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports